import thPicker from "antd/es/date-picker/locale/th_TH";

const thBEPicker = {
  ...thPicker,
  lang: {
    ...thPicker.lang,
    yearFormat: "BBBB", // แสดงปี พ.ศ. ใน header
    cellYearFormat: "BBBB", // ปีใน year panel เป็น พ.ศ.
    monthFormat: "MMMM", // ชื่อเดือนภาษาไทยเต็ม
  },
};

export default thBEPicker;
